<template>
 <div>
    <label v-if="!$parent.event.sessions || !$parent.event.sessions.length"><b>
       No sessions in this event.</b>
    </label>
    <b-card-group deck class="session_deck">
      <div v-for="(session,index) in $parent.event.sessions"
          class="card session_card">
        <div style="width:100%;text-align:center;">
          <img style="max-width:100%;max-height:10rem;height:auto;vertical-align:middle;" :src="session.banner">
          </img>
        </div>
        <div class="card-body" style="position:relative">
          <h4 class="card-title">
            {{ session.title }}
          </h4>
          <b-card-text>
            <div>
              <b>{{ room_dname($parent.event,session.roomname) }}</b>
            </div>
            <div class="date_time">
              {{ datestring(session) }}
              <add-to-cal
                :title="session.title"
                :startep="session.startep"
                :endep="session.endep"
                :descr="session.description"
                :url="get_session_url(session)"
              />
            </div>
            <div v-if="session.speakers && session.speakers.length"
              class="mt-2">
              <div v-for="speaker in session.speakers">
                 <img v-if="speaker.pic" :src="speaker.pic" class="speakerimg"/>
                 <b> {{ speaker.name }} </b>
                 <b-link v-if="speaker.bio" @click="openbio(speaker.bio)">(Bio)
                 </b-link>
              </div>
            </div>
            <div v-if="session.description"
               class="mt-2">
               {{ session.description }}
            </div>

             <div v-if="session.session_sponsors">
            <div
              v-if="session.session_sponsors.length > 0"
              class="sponsers-card"
            >
              <div>Sponsors</div>
              <span
                v-for="name in session.session_sponsors"
                title=""
                sub-title=""
                class="sponsorcard"
              >
                <img
                  left
                  fluid
                  :src="getSponsor(name).logo"
                  @click="openbio(getSponsor(name).url)"
                  class="sponsorimg"
                />
              </span>
            </div>
            </div>

            <div v-if="session_status($parent.event,session) == 'ended'"
               class="mt-2"
               style="color:red">
               The session has ended.
            </div>
            <div v-if="session_status($parent.event,session) == 'soon'">
              <div style="color:red"> Starting Soon </div>
              <div v-if="!$parent.registered"
                 style="color:red">
                 To join, please register in Reception.
              </div>
              <b-button :disabled="!$parent.registered"
                  variant="success"
                 @click="$parent.goto_room(session.roomname)">
                 Join 
              </b-button>
            </div>
            <div v-if="session_status($parent.event,session) == 'active'">
              <div v-if="!$parent.registered"
                 style="color:red">
                 To join, please register in Reception.
              </div>
              <b-button :disabled="!$parent.registered"
                 variant="success"
                 @click="$parent.goto_room(session.roomname)">
                 Join 
              </b-button>
            </div>
          </b-card-text>
        </div>
      </div>
    </b-card-group>
 </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import AddToCal from "../components/AddToCal";

export default {
  name: "sessions",
  data() {
    return {
      eventsponsors:[]
    };
  },
  components: {
    AddToCal,
  },
  created() {
     this.setup();
  },
  methods: {
    datestring: utils.datestring, 
    openbio: utils.openbio, 
    room_dname: utils.room_dname,
    session_status: utils.session_status,
    get_session_url: function (session) {
      /* Room URL or Sessions page? */
      //let hash = vue.$router.resolve({name:'sessions', id:$parent.event.id}).href;
      let hash = "#/room/" + session.roomname;
      let url = window.location.href.split("#")[0] + hash;
      return url;
    },
    getSponsor(name) {
      return this.eventsponsors[name] || {};
    },
    setup: function () {
      let vue = this;
      vue.$parent.event.sponsors.forEach(function(sponsor) {
      vue.eventsponsors[sponsor.name] = sponsor;
    });
    },
  },
  computed: {},
  beforeDestroy() {},
  mounted() {
    $("body").removeClass("setbackground");
  },
};
</script>

<style lang="scss" scoped>
.session_deck {
  justify-content: center;
  margin-right:0;
  margin-left:0;
}
.session_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 20rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
.date_time {
  font-size:1.1rem;
  font-weight:600;
  text-align:left;
  color:black;
  padding-bottom: 1rem;
}
.para {
  white-space: pre-wrap;
}
.speakerimg {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  padding: 2px 0px;
}
.sponsers-card {
  padding: 10px 0;
  margin: 10px;
}
.sponsorcard {
  min-width: 10rem;
  max-width: 20rem;
  min-height: 10rem;
  margin: 0 1rem;
  border: none;
}
.sponsorimg {
  max-width: 4rem;
  max-height: 2rem;
  cursor: pointer;
}
</style>